<template>
    <div id="containerApp" class="container-top" v-loading.fullscreen.lock="loading">
        <page-header v-if="!noneHeader"></page-header>
        <router-view/>
        <side-menu></side-menu>
        <div class="blur-bg"></div>
    </div>
</template>

<script>
import EventBus from "@/utils/event-bus";
import util from "@/mixins/util";
import SideMenu from "@/components/SideMenu.vue";

export default {
    name: "App",
    mixins: [],
    components: {
        SideMenu
    },
    provide() {
        return {}
    },
    props: {},
    data() {
        return {
            passPath: ['/auth/register'],
            loading: false,
            loadingText: '',

        }
    },
    created() {
        let token = this.$localStorage.get('token');
        if (!util.isEmpty(token)) {
            this.$store.dispatch('userInfo/setUserInfo', {token});
        }
    },
    mounted() {
        EventBus.$on('apiLoading', this.apiLoading);
    },
    beforeDestroy() {
        EventBus.$off('apiLoading')
    },
    destroyed() {
    },
    computed: {
        noneHeader() {
            return this.$route.path === '/auth'
        }
    },
    methods: {
        apiLoading(value, text = '') {
            this.loading = value;
            if (!value) {
                this.loadingText = '';
            } else {
                this.loadingText = text;
            }
            return new Promise((resolve, reject) => {
                setTimeout(() => {
                    resolve(true);
                }, 50)
            })
        },


    },
    watch: {},
}
</script>

<style lang="scss">
@import "./assets/scss/index.scss";

</style>
